import React, { useRef } from 'react';
import { Calendar } from 'lucide-react';

const TODAY = new Date().toISOString().split('T')[0];

const UserFriendlyDateInput = ({ id, name, value, onChange, disabled, className, placeholder, max = TODAY, min }) => {
  const inputRef = useRef(null);

  const handleIconClick = () => {
    if (inputRef.current) {
      try {
        inputRef.current.showPicker();
      } catch (e) {
        // Fallback for browsers that don't support showPicker
        inputRef.current.focus();
      }
    }
  };

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%' }}>
      <input
        ref={inputRef}
        type="date"
        id={id}
        name={name}
        className={className}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        max={max}
        min={min}
        style={{ width: '100%', paddingRight: '40px' }}
        data-date-format="DD/MM/YYYY"
      />
      <div 
        onClick={handleIconClick}
        title="Open Calendar"
        style={{ 
          position: 'absolute', 
          right: '10px', 
          cursor: disabled ? 'not-allowed' : 'pointer',
          color: disabled ? '#9ca3af' : '#4b5563',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '4px'
        }}
      >
        <Calendar size={18} />
      </div>
    </div>
  );
};

export default UserFriendlyDateInput;
